import React from 'react';
import { CustomFlagIndicator } from '../../job-indicators';

export default function CustomFlagBadge({ flag, flagTemplates = [] }) {
  // We'll reuse the CustomFlagIndicator from job-indicators.js
  return <CustomFlagIndicator flag={flag} flagTemplates={flagTemplates} />;
}
